import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import ContactModal from '../ContactModal';
import { Box, Flex, Text } from 'core/ui/atoms';
import { ReactComponent as EditLine } from 'core/assets/images/V2/icons/EditLine.svg';
import useUser from 'core/hooks/useUser';

const ContactInfo = ({ title = 'Contact Information' }) => {
  const [openModal, setOpenModal] = useState(false);
  const { currentUser } = useUser();
  const { email, phoneNumber, firstName, lastName } = currentUser;

  return (
    <CustomBox>
      <Flex justifyContent='space-around'>
        <AddressContainer>
          <HeaderText>{title}</HeaderText>
          <AddressText>{`${firstName} ${lastName}`}</AddressText>
          <AddressText>{phoneNumber}</AddressText>
          <AddressText>{email}</AddressText>
        </AddressContainer>
        <EditLine onClick={() => setOpenModal(true)} />
      </Flex>
      {openModal && <ContactModal closeModal={() => setOpenModal(false)} />}
    </CustomBox>
  );
};

ContactInfo.propTypes = {
  title: PropTypes.string,
};

const CustomBox = styled(Box)`
  width: 100%;
  padding-bottom: 20px;
`;


const AddressContainer = styled(Box)`
  width: 100%;
`;

const AddressText = styled(Text)`
  font-family: ${({ theme }) => theme.typography.familyPoppins};
  font-weight: 400;
  font-size: 12px;
  line-height: 22px;
  letter-spacing: 0%;
  margin: 2px;
`;

const HeaderText = styled(Text)`
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  line-height: 22px;
  font-family: ${({ theme }) => theme.typography.familyLarken};
`;

export default ContactInfo;
